var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterFxEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 0.976562,
    width: 21,
    height: 21,
    rx: 2,
    fill: "#2249FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.65396 14.3059V16.3251H7.67319L13.623 10.3752L11.6038 8.35605L5.65396 14.3059ZM15.1848 8.81354C15.4001 8.59821 15.4001 8.27506 15.1848 8.05973L13.9193 6.79431C13.704 6.57898 13.3809 6.57898 13.1655 6.79431L12.1694 7.79052L14.1886 9.8097L15.1848 8.81354Z",
    fill: "#2249FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFxEditIcon);
export default __webpack_public_path__ + "static/media/FilterFxEditIcon.f159f309aba989ced6959f8b58ec4165.svg";
export { ForwardRef as ReactComponent };